import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators'; 

export default {
    
    checkIsMember: function () {
        let params = { 
        };
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/transfermaai/member';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => { 
            return res.data;
        }));
    },

    pointTranfer: function (point, refTransactionId) {
        let params = { 
            point: point
        };
        if (refTransactionId) {
            params.refTransactionId = refTransactionId;
        }
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/transfermaai/point_tranfer';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => { 
            return res.data;
        }));
    }, 
}
